<template>
	<section>
		<v-card style="padding: 10px;">
		<div class="my-3">
			<v-container grid-list-md>
        <v-card-title><h2>Event Configuration</h2></v-card-title>
        <v-divider/>
				<v-layout wrap row>
					<v-flex xs12 lg6>
						<v-layout wrap row>
							<!--<v-flex xs12>-->
								<!--<e-color-picker label="Background color"-->
	    										<!--v-model="formData.eventConfiguration.backgroundColor"-->
                          <!--@colorChange="setBackgroundColor"-->
	    										<!--/>-->
							<!--</v-flex>-->
							<!--<v-flex xs12>-->
								<!--<e-color-picker label="Text Color"-->
	    										<!--v-model="formData.eventConfiguration.color"-->
                          <!--@colorChange="setFontColor"-->
	    										<!--/>-->
							<!--</v-flex>-->
	            <!--<v-flex xs12 lg4>-->
	            	<!--<v-select :items="dateDisplayTypes"-->
	            						<!--auto-->
	                        <!--v-model="formData.eventConfiguration.dateDisplayType"-->
	                        <!--required-->
	                        <!--/>-->
	            <!--</v-flex>-->
	            <v-flex xs0 lg12/>
	            <v-flex xs12 lg6>
									<h3>Event start date</h3>
		            	<v-date-picker
		              				v-model="formData.eventConfiguration.startDate"
                          header-color="primary"
                  />
		              <div v-if="$v.formData.eventConfiguration.startDate.$invalid" class="red--text my-2">Select start date</div>
	            </v-flex>
	            <v-flex xs12 lg6>
	            	<h3>Event end date</h3>
	              	<v-date-picker
	              					v-model="formData.eventConfiguration.endDate" />
	              	<div v-if="$v.formData.eventConfiguration.endDate.$invalid" class="red--text my-2">Select end date</div>
	            </v-flex>
              <div v-if="isStartDateBiggerEndDate" class="red--text my-2">Start date should not be bigger than end date</div>
          	</v-layout>
          </v-flex>
				</v-layout>
        <br>
        <br>
        <v-card-title><h2>Session Configuration</h2></v-card-title>
        <v-divider/>
				<v-layout wrap row>
					<v-flex xs12 lg6>
						<v-layout wrap row>
						<v-flex xs12>
							<h3>Ask question</h3>
							<v-layout wrap row>
								<v-flex xs12>
									<content-field
                    label="Question Placeholder"
										multiLine
										v-model="formData.sessionConfiguration.askQuestion.text"
										:error="$v.formData.sessionConfiguration.askQuestion.text"
									/>
								</v-flex>
								<v-flex xs12>
									<content-field
										type="number"
										label="Question characters limit"
										v-model="formData.sessionConfiguration.askQuestion.charactersLimit"
									/>
								</v-flex>
								<v-flex xs12>
									<content-field
										multiLine
                    label="Email Placeholder"
										v-model="formData.sessionConfiguration.askQuestion.inputPlaceholder"
										:error="$v.formData.sessionConfiguration.askQuestion.inputPlaceholder"
									/>
								</v-flex>
								<v-flex xs12>
									<content-field
										label="Question title"
										v-model="formData.sessionConfiguration.askQuestion.title"
										:error="$v.formData.sessionConfiguration.askQuestion.title"
									/>
								</v-flex>
						</v-layout>
							</v-flex>
							<v-flex xs12>
								<content-field
									type="email"
									label="Email"
									v-model="formData.sessionConfiguration.emailAddress"
									:error="$v.formData.sessionConfiguration.emailAddress"
								/>
							</v-flex>
							<v-flex xs4>
								<v-select
									label="Time font weight"
									:items="fontWeights"
									v-model="formData.sessionConfiguration.timeFontWeight"
								/>
							</v-flex>
							<v-flex xs4>
								<v-select
									label="Title font weight"
									:items="fontWeights"
									v-model="formData.sessionConfiguration.titleFontWeight"
								/>
							</v-flex>
              <v-flex xs4>
                <v-checkbox
                  v-model="formData.sessionConfiguration.hideStartTime"
                  :label="`Hide start time`"
                ></v-checkbox>
              </v-flex>
              <!-- This setting is not implemented on FrontSide, uncomment it when needed -->
							<!--<v-flex xs12>-->
								<!--<e-color-picker-->
									<!--label="Title color"-->
									<!--v-model="formData.sessionConfiguration.titleColor"-->
                  <!--@colorChange="setTitleColor"-->
								<!--/>-->
							<!--</v-flex>-->
              <v-flex xs4>
                <v-card-actions>
                  <v-btn @click="resetForm" color="info">Reset</v-btn>
                  <v-btn @click="save" color="info">Save</v-btn>
                </v-card-actions>
              </v-flex>
					</v-layout>
					</v-flex>
				</v-layout>
			</v-container>
		</div>
	</v-card>
	</section>
</template>

<script>
import ContentField from '@/components/shared/ContentField'
import EColorPicker from '@/components/shared/EColorPicker'
import { required, email, numeric } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import { clone, path, omit } from 'ramda'
import mixins from '@/utils/mixins'

export default {
  name: 'AgendaEventsSettings',
  mixins: [mixins.isWriteAvailable],
  components: {
    EColorPicker,
    ContentField
  },
  computed: {
    ...mapGetters({
      getGeneralSettings: 'getSettings'
    }),
    isStartDateBiggerEndDate () {
      const startDateTime = new Date(this.formData.eventConfiguration.startDate).getTime()
      const endDateTime = new Date(this.formData.eventConfiguration.endDate).getTime()
      return startDateTime > endDateTime
    },
    agendaSettings () {
      return path(['agendaSetting'], this.getGeneralSettings)
    }
  },
  data () {
    return {
    formData: {},
    dateDisplayTypes: ['Dates', 'Counter'],
    fontWeights: [100, 200, 300, 400, 500, 600, 700],
    startDateBiggerEndDateError: false,
    defaultFormData: {
      eventConfiguration: {
        backgroundColor: '',
        color: '',
        dateDisplayType: 'Dates',
        endDate: '2019-09-03',
        startDate: '2020-02-15'
      },
      id: '',
      sessionConfiguration: {
        askQuestion: {
          text: '',
          charactersLimit: 20,
          inputPlaceholder: '',
          title: ''
        },
        emailAddress: '',
        timeFontWeight: 300,
        titleFontWeight: 500,
        titleColor: '',
        hideStartTime: true
      }
    },
    // DON'T DELETE! need for isWriteAvailable mixin
    scopeForWrite: 'agenda:write'
  }
  },
  validations: {
    formData: {
      eventConfiguration: {
        dateDisplayType: {required},
        endDate: {required},
        startDate: {required}
      },
      sessionConfiguration: {
        askQuestion: {
        text: {required},
        inputPlaceholder: {required},
        title: {required}
      },
      emailAddress: {required, email},
      timeFontWeight: {required, numeric},
      titleFontWeight: {required, numeric}
      }
    }
  },
  methods: {
    ...mapActions(['fetchGeneralSettings', 'editSettings']),
    async save () {
      // titleColor setting is not implemented on FS, uncomment when needed
      // this.formData.sessionConfiguration.titleColor = path(['sessionConfiguration', 'titleColor', 'hex'], this.formData)
      // this.formData.eventConfiguration.backgroundColor = path(
      //   ['backgroundColor', 'hex'],
      //   this.formData.eventConfiguration
      // )
      // this.formData.eventConfiguration.color = path(
      //   ['color', 'hex'],
      //   this.formData.eventConfiguration
      // )
      this.formData.eventConfiguration.startDate = `${this.formData.eventConfiguration.startDate}T00:00:00Z`
      this.formData.eventConfiguration.endDate = `${this.formData.eventConfiguration.endDate}T23:59:00Z`
      this.$v.formData.$touch()
      if (this.$v.formData.$invalid || this.isStartDateBiggerEndDate) return
      const payload = clone(this.formData)
      await this.editSettings(payload)
      this.getSettings()
    },
    resetForm () {
      this.formData = clone(this.defaultFormData)
      this.$bus.$emit('resetColorPicker')
      this.$v.$reset()
    },
    parseDate (value) {
      return value.substring(0, 10)
    },
    // setBackgroundColor ({ hex }) {
    //   this.formData.eventConfiguration.backgroundColor.hex = hex
    // },
    // setFontColor ({ hex }) {
    //   this.formData.eventConfiguration.color.hex = hex
    // },
    setTitleColor ({ hex }) {
      this.formData.sessionConfiguration.titleColor.hex = hex
    },
    async getSettings () {
      this.resetForm()
      await this.fetchGeneralSettings()
      this.defaultFormData = clone(this.agendaSettings)
    // titleColor setting is not implemented on FS, uncomment when needed
    //   this.defaultFormData.sessionConfiguration.titleColor = {
    //     hex: this.defaultFormData.sessionConfiguration.titleColor || '#000000'
    // }
    // this.defaultFormData.eventConfiguration.backgroundColor = {
      //   hex: this.defaultFormData.eventConfiguration.backgroundColor
      // }
      // this.defaultFormData.eventConfiguration.color = {
      //   hex: this.defaultFormData.eventConfiguration.color
      // }
      this.defaultFormData.eventConfiguration.startDate = this.parseDate(this.defaultFormData.eventConfiguration.startDate)
      this.defaultFormData.eventConfiguration.endDate = this.parseDate(this.defaultFormData.eventConfiguration.endDate)
      this.formData = clone(this.defaultFormData)
    }
  },
  created () {
    this.getSettings()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Agenda/EventsSettings/index.vue